import React from 'react';
import { Row, Col, Table, Card, Form } from 'react-bootstrap';
import Pagination from 'react-js-pagination';
import { useTranslation, Trans } from 'react-i18next';
import { DebounceInput } from 'react-debounce-input';
import BootstrapTable from 'react-bootstrap-table-next';
import './Line.css';

const ListingReportsVendor = ({
  reports,
  filters,
  stateFilters,
  handleFilterChange,
  exportData
}) => {
  const { t } = useTranslation();

  const handlePageChange = page => handleFilterChange({ page });

  let detailsArray = [];

  const totalEntries = report => {
    let count = 0;
    report.funds.map(fund => {
      count += Number(fund.current_value);
    });
    return count.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    });
  };

  const totalExit = report => {
    let countExit = 0;
    report.actions.map(action =>
      action.all_values.map(value => {
        countExit += Number(value.actual_value);
      })
    );

    return countExit.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    });
  };

  const margin = report => {
    let spent = 0;
    let collected = 0;
    let margin = 0;
    let countMargin = 0;
    report.funds.map(fund => {
      collected += Number(fund.current_value);
    });
    report.actions.map(action =>
      action.all_values.map(value => {
        spent += Number(value.actual_value);
      })
    );
    margin = collected - spent;
    countMargin += margin;
    return countMargin.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    });
  };

  const mdf = report => {
    let spent = 0;
    let collected = 0;
    let margin = 0;
    let countMDF = 0;
    report.funds.map(fund => {
      if (fund.type_id === 1) {
        collected += Number(fund.current_value);
      }
    });
    report.actions.map(action =>
      action.all_values.map(value => {
        if (value.fund_type_id === 1) {
          spent += Number(value.actual_value);
        }
      })
    );
    margin = collected - spent;
    countMDF += margin;
    return countMDF.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    });
  };

  const entriesMDF = report => {
    let countEntriesMDF = 0;
    report.funds.map(fund => {
      if (fund.type_id === 1) {
        countEntriesMDF += Number(fund.current_value);
      }
    });
    return countEntriesMDF.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    });
  };

  const exitMDF = report => {
    let countExitMDF = 0;
    report.actions.map(action =>
      action.all_values.map(value => {
        if (value.fund_type_id === 1) {
          countExitMDF += Number(value.actual_value);
        }
      })
    );
    return countExitMDF.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    });
  };

  const entriesBU = report => {
    let countEntriesBU = 0;
    report.funds.map(fund => {
      if (fund.type_id === 2) {
        countEntriesBU += Number(fund.current_value);
      }
    });
    return countEntriesBU.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    });
  };

  const exitBU = report => {
    let countExitBU = 0;
    report.actions.map(action =>
      action.all_values.map(value => {
        if (value.fund_type_id === 2) {
          countExitBU += Number(value.actual_value);
        }
      })
    );
    return countExitBU.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    });
  };

  const bu = report => {
    let spent = 0;
    let collected = 0;
    let margin = 0;
    let countBU = 0;
    report.funds.map(fund => {
      if (fund.type_id === 2) {
        collected += Number(fund.current_value);
      }
    });
    report.actions.map(action =>
      action.all_values.map(value => {
        if (value.fund_type_id === 2) {
          spent += Number(value.actual_value);
        }
      })
    );
    margin = collected - spent;
    countBU += margin;
    return countBU.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    });
  };

  const entriesOwn = report => {
    let countEntriesOwn = 0;
    report.funds.map(fund => {
      if (fund.type_id === 3) {
        countEntriesOwn += Number(fund.current_value);
      }
    });
    return countEntriesOwn.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    });
  };

  const exitOwn = report => {
    let countExitOwn = 0;
    report.actions.map(action =>
      action.all_values.map(value => {
        if (value.fund_type_id === 3) {
          countExitOwn += Number(value.actual_value);
        }
      })
    );
    return countExitOwn.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    });
  };

  const own = report => {
    let spent = 0;
    let collected = 0;
    let margin = 0;
    let countOwn = 0;
    report.funds.map(fund => {
      if (fund.type_id === 3) {
        collected += Number(fund.current_value);
      }
    });
    report.actions.map(action =>
      action.all_values.map(value => {
        if (value.fund_type_id === 3) {
          spent += Number(value.actual_value);
        }
      })
    );
    margin = collected - spent;
    countOwn += margin;
    return countOwn.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    });
  };

  const entriesExtra = report => {
    let countExtra = 0;
    report.funds.map(fund => {
      if (fund.type_id === 4) {
        countExtra += Number(fund.current_value);
      }
    });
    return countExtra.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    });
  };

  const exitExtra = report => {
    let countExitExtra = 0;
    report.actions.map(action =>
      action.all_values.map(value => {
        if (value.fund_type_id === 4) {
          countExitExtra += Number(value.actual_value);
        }
      })
    );
    return countExitExtra.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    });
  };

  const extra = report => {
    let spent = 0;
    let collected = 0;
    let margin = 0;
    let countExtra = 0;
    report.funds.map(fund => {
      if (fund.type_id === 4) {
        collected += Number(fund.current_value);
      }
    });
    report.actions.map(action =>
      action.all_values.map(value => {
        if (value.fund_type_id === 4) {
          spent += Number(value.actual_value);
        }
      })
    );
    margin = collected - spent;
    countExtra += margin;
    return countExtra.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    });
  };

  const getDetails = rowId => {
    detailsArray = [];
    {
      reports.data.map(report => {
        let detail = {
          id: report.id,
          entriesMDF: entriesMDF(report),
          exitMDF: exitMDF(report),
          entriesBU: entriesBU(report),
          exitBU: exitBU(report),
          entriesOwn: entriesOwn(report),
          exitOwn: exitOwn(report),
          entriesExtra: entriesExtra(report),
          exitExtra: exitExtra(report),
          totalEntries: totalEntries(report),
          totalExit: totalExit(report)
        };

        if (report.id === rowId) {
          detailsArray.push(detail);
        }
      });
    }
  };

  const columns = [
    {
      dataField: 'btn',
      text: '',
      headerStyle: {
        width: '4%'
      },
      style: {
        textAlign: 'center'
      }
    },
    {
      dataField: 'name',
      text: t('label:company'),
      headerStyle: {
        textAlign: 'center'
      },
      style: {
        textAlign: 'center'
      }
    },
    {
      dataField: 'mdf',
      text: t('label:MDF'),
      headerStyle: {
        textAlign: 'center'
      },
      style: {
        textAlign: 'center'
      }
    },
    {
      dataField: 'bu',
      text: t('label:BU'),
      headerStyle: {
        textAlign: 'center'
      },
      style: {
        textAlign: 'center'
      }
    },
    {
      dataField: 'own',
      text: t('label:own'),
      headerStyle: {
        textAlign: 'center'
      },
      style: {
        textAlign: 'center'
      }
    },
    {
      dataField: 'extra',
      text: t('label:extra'),
      headerStyle: {
        textAlign: 'center'
      },
      style: {
        textAlign: 'center'
      }
    },
    {
      dataField: 'margin',
      text: t('label:margin'),
      headerStyle: {
        textAlign: 'center'
      },
      style: {
        textAlign: 'center'
      }
    }
  ];

  const expandRow = {
    renderer: row => (
      <>
        <Table bordered hover responsive>
          <tbody className="table-borderless">
            {getDetails(row.id)}
            {detailsArray.map(info => (
              <tr key={info.id}>
                <td className="text-center align-middle">
                  <p>Entradas</p>
                  <p>Gastos</p>
                </td>
                <td className="text-center align-middle"></td>
                <td className="text-center align-middle">
                  <p>{info.entriesMDF}</p>
                  <p>{info.exitMDF}</p>
                </td>
                <td className="text-center align-middle">
                  <p>{info.entriesBU}</p>
                  <p>{info.exitBU}</p>
                </td>
                <td className="text-center align-middle">
                  <p>{info.entriesOwn}</p>
                  <p>{info.exitOwn}</p>
                </td>
                <td className="text-center align-middle">
                  <p>{info.entriesExtra}</p>
                  <p>{info.exitExtra}</p>
                </td>
                <td className="text-center align-middle">
                  <p>{info.totalEntries}</p>
                  <p>{info.totalExit}</p>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </>
    )
  };

  function btn() {
    return <i className="fas fa-plus-circle"></i>;
  }

  const reportsData = [];

  function getReports() {
    let teste = [];
    reports.data.map(report => {
      teste = reportsData.push({
        id: report.id,
        btn: btn(),
        name: report.name+' / '+report.alias,
        mdf: mdf(report),
        bu: bu(report),
        own: own(report),
        extra: extra(report),
        margin: margin(report)
      });
    });
  }

  const getExportTable = (reports) => {
    const getDetails = report => {
      return [{
        entriesMDF: entriesMDF(report).replace(String.fromCharCode(160),' '),
        exitMDF: exitMDF(report).replace(String.fromCharCode(160),' '),
        entriesBU: entriesBU(report).replace(String.fromCharCode(160),' '),
        exitBU: exitBU(report).replace(String.fromCharCode(160),' '),
        entriesOwn: entriesOwn(report).replace(String.fromCharCode(160),' '),
        exitOwn: exitOwn(report).replace(String.fromCharCode(160),' '),
        entriesExtra: entriesExtra(report).replace(String.fromCharCode(160),' '),
        exitExtra: exitExtra(report).replace(String.fromCharCode(160),' '),
        totalEntries: totalEntries(report).replace(String.fromCharCode(160),' '),
        totalExit: totalExit(report).replace(String.fromCharCode(160),' ')
      }];
    }
    let reportsData = reports.map(report => {
      return {
        id: report.id,
        name: report.name+' / '+report.alias,
        mdf: mdf(report).replace(String.fromCharCode(160),' '),
        bu: bu(report).replace(String.fromCharCode(160),' '),
        own: own(report).replace(String.fromCharCode(160),' '),
        extra: extra(report).replace(String.fromCharCode(160),' '),
        margin: margin(report).replace(String.fromCharCode(160),' '),
        detail:getDetails(report)
      };
    });


    let columns_aux = columns.filter(a=>a.text);
    
    return (
      <table>
        <thead>
          <tr>
            {columns_aux.map((c,k)=>{
              return (<th key={k}>{c.text}</th>);
            })}
          </tr>
        </thead>
        <tbody>
          {reportsData.map((a,k)=>{
            return (<>
            <tr key={k}>{columns_aux.map((c,k2)=>{
              return (<td key={k2}>{a[c.dataField]}</td>);
            })}</tr>
            {a.detail.map(info => (<>
              <tr key={info.id}>
                <td className="text-center align-middle">
                  <p>Entradas</p>
                </td>
                <td className="text-center align-middle">
                  <p>{info.entriesMDF}</p>
                </td>
                <td className="text-center align-middle">
                  <p>{info.entriesBU}</p>
                </td>
                <td className="text-center align-middle">
                  <p>{info.entriesOwn}</p>
                </td>
                <td className="text-center align-middle">
                  <p>{info.entriesExtra}</p>
                </td>
                <td className="text-center align-middle">
                  <p>{info.totalEntries}</p>
                </td>
              </tr>
              <tr key={info.id}>
                <td className="text-center align-middle">
                  <p>Gastos</p>
                </td>
                <td className="text-center align-middle">
                  <p>{info.exitMDF}</p>
                </td>
                <td className="text-center align-middle">
                  <p>{info.exitBU}</p>
                </td>
                <td className="text-center align-middle">
                  <p>{info.exitOwn}</p>
                </td>
                <td className="text-center align-middle">
                  <p>{info.exitExtra}</p>
                </td>
                <td className="text-center align-middle">
                  <p>{info.totalExit}</p>
                </td>
              </tr></>
            ))}
            <tr><td  className="text-center align-middle">{''}</td></tr>
            </>
            );
          })}
        </tbody>
      </table>
    )
  };

  if(exportData) return getExportTable(exportData);

  getReports();
  return (
    <>
      <Row>
        <Col>
          <Row className="justify-content-end">
            {filters.map((filter, k) => (
              <Col key={k} md={3}>
                <Form.Group>
                  <Form.Label>{t(`label:${filter.name}`)}</Form.Label>
                  <Form.Control
                    value={stateFilters[filter.key]}
                    onChange={e =>
                      handleFilterChange({
                        [filter.key]: e.target.value,
                        page: 1
                      })
                    }
                    as="select"
                  >
                    <option value="">{t('label:all')}</option>
                    {filter.options.map((option, k) => (
                      <option key={k} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Col>
            ))}
          </Row>
          <Row>
            <Col md={3}>
              <Form.Group>
                <Form.Label>{t('label:records per page')}:</Form.Label>
                <Form.Control
                  as="select"
                  value={stateFilters.per_page}
                  onChange={e =>
                    handleFilterChange({ per_page: e.target.value, page:1 })
                  }
                >
                  <option value={10}>10</option>
                  <option value={25}>25</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                </Form.Control>
              </Form.Group>
            </Col>
            <Col md={3} className="ml-auto">
              <Form.Group>
                <Form.Label>{t('label:search')}:</Form.Label>
                <DebounceInput
                  element={Form.Control}
                  debounceTimeout={500}
                  value={stateFilters.__search}
                  onChange={e => handleFilterChange({ __search: e.target.value, page:1 })}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <BootstrapTable
                id="vendor-report-table"
                classes="table-condensed"
                wrapperClasses='table-responsive'
                responsive
                keyField="id"
                data={reportsData}
                columns={columns}
                expandRow={expandRow}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <Trans i18nKey="label:interpolateShowingRecords">
                Showing {{ from: reports.pagination.from || '0' }} to{' '}
                {{ to: reports.pagination.to || '0' }} from {{ total: reports.pagination.total }}{' '}
                records
              </Trans>
            </Col>
            <Col className="d-flex justify-content-end">
              <Pagination
                activePage={reports.pagination.current_page}
                itemsCountPerPage={reports.pagination.per_page}
                totalItemsCount={reports.pagination.total}
                pageRangeDisplayed={5}
                onChange={handlePageChange}
                itemClass="page-item"
                linkClass="page-link"
                prevPageText="‹"
                nextPageText="›"
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default ListingReportsVendor;
